import React from 'react';
import { useResponseContext } from 'js/engines/CapabilitiesAssessment/ResponseContext';
import StandardQuestionResponses from './StandardQuestionResponses';

import styles from './PageReview.module.scss';

/** A participant's own answers to a standard page, before they finish. */
function StandardQuestionsPageReview({ page }) {
  const { responses, questionMap } = useResponseContext();

  return (
    <div className={styles['page-review'] + ' question-results'}>
      <StandardQuestionResponses
        page={page}
        questionMap={questionMap}
        responses={responses}
      />
    </div>
  );
}

export default StandardQuestionsPageReview;
